import { useEffect } from 'react'

function useUnmount(func) {
  useEffect(() => func, [])
}

export default useUnmount
